/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { Button , Row , Col } from 'react-bootstrap';
import { TransitionGroup } from 'react-transition-group';
import Alert from '../alert.js';
import Translation from  '../../store/internationalization-store.js';

export default class Step extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state ={
            advanceDisabled: false,
            retreatDisabled: false,
            data:this.props.data,
            information:this.props.information
        };
    }

    handleKeyPress(target) {
        if(target.charCode==13){
            this.onSubmit();
        }
    }

    componentWillMount(){
        // $(document).on('keypress', this._handleDocumentClick);
    }


    componentWillUnmount() {
        // $(document).off('keypress' , this._handleDocumentClick);
    }

    onAdvance(err){
        if(err){
            this.setState({advanceDisabled: false, retreatDisabled: false, currentError: err});
        }else{
            this.props.onAdvance();
        }
    }

    onSubmit(){
        this.setState({
            advanceDisabled: true,
            retreatDisabled: true
        });
        this.props.onSubmit.apply(this, [this.onAdvance.bind(this)]);
    }

    onBack(){

        console.log(this);
        if(this.props.onBack){
            this.props.onBack.apply(this, [this.props.onRetreat]);
        }else{
            this.props.onRetreat();
        }
    }


    render(){

        var AdvanceButton;
        var DefaultAdvanceButton;
        if(!this.props.lastStep){
            AdvanceButton = React.createElement(Button, {
                onClick: this.onSubmit.bind(this),
                disabled: this.state.advanceDisabled,
                bsStyle:'primary',
                className:"btn-block",
            },Translation.get(631 ,'Next'));
        }


        var RetreatButton;
        if(!this.props.lastStep){
            RetreatButton = React.createElement(Button, {
                onClick: this.onBack.bind(this),
                disabled: this.props.firstStep || this.state.retreatDisabled,
                bsStyle:'primary',
                className:"btn-block",
                smHidden:true
            },Translation.get(116 ,'Back'));
        }

        var ComponentClass = this.props.component;

        var Error;
        if(this.state.currentError && !this.props.handelError){
            Error =    <div><br/><Alert  variant={"danger"}>{this.state.currentError.message}</Alert></div>
        }


        let buttons = <Row>
            <Col className="pull-right" sm={{span: 3, offset: 6}}>{RetreatButton}</Col>
            <Col className="pull-right" sm={3}>{AdvanceButton}</Col>
        </Row>;

        if(this.props.disableButtons) buttons = null;

        return <div className="step">

           
            <ComponentClass  reset={this.props.reset} information={this.props.information} onModify={this.props.onModify} onSubmit={AdvanceButton} Error={Error} data={this.props.data}  forceBack={this.onBack.bind(this)} forceAdvance={this.onSubmit.bind(this)}/>
            <TransitionGroup transitionName="example" transitionAppearTimeout={500} transitionAppear={true} transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                {Error}
            </TransitionGroup>
            <br/>
            {buttons}
        </div>;
    }
}

